import { useAuth0 } from '@auth0/auth0-react';
import TextInput from '../TextInput';
import { useUserInfoQuery } from '../../lib/Queries';
import GoogleIcon from '../icons/GoogleIcon.jsx';
import GoogleSocialIcon from '../icons/GoogleSocialIcon.jsx';
import React, { useEffect, useState } from 'react';
import useBusinessPostApi from '../../lib/useBusinessPostApi.js';
import usePostApi from '../../lib/usePostApi.js';
import * as Toast from '../../lib/Toast.js';
import LogoutIcon from '../icons/LogoutIcon.jsx';
import { Link } from 'react-router-dom';
import AuditLogs from "~/components/AuditLogs";

const SecuritySettings = ({}) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [passwordVerify, setPasswordVerify] = useState('');
    const [showAuditLog, setShowAuditLog] = useState(false)

    const { save, isSaving } = usePostApi(`/api/userinfo`);

    const { user, isAuthenticated, isLoading } = useAuth0();
    const { data, refetch } = useUserInfoQuery();

    let socialType = user?.sub.split('|')[0];
    if (socialType === 'auth0') {
        socialType = '';
    } else if (socialType === 'google-oauth2') {
        socialType = 'Google';
    }

    useEffect(() => {
        setEmail(data?.email);
    }, [JSON.stringify(data)]);

    function submit(ev) {
        ev.preventDefault();

        save({
            email: email,
            password: password,
            passwordVerify: passwordVerify,
        }).then(result => {
            refetch();
            Toast.success('Successfully updated login');
        });
    }

    return (
        <div>
            {!!socialType && (
                <div>
                    <TextInput
                        label="Email"
                        value={data?.email}
                        readOnly={true}
                        onChange={() => null}
                    />

                    <div className="flex items-center mt-2">
                        {socialType === 'Google' && <GoogleSocialIcon />}
                        <span className="ml-2">
                            Currently signed in with {socialType}
                        </span>
                    </div>
                </div>
            )}
            {!socialType && (
                <form onSubmit={submit}>
                    <TextInput
                        label="Email"
                        id="email"
                        value={email}
                        onChange={setEmail}
                        className="mb-4"
                    />

                    <TextInput
                        label="New Password"
                        type="password"
                        id="password"
                        value={password}
                        onChange={setPassword}
                        className="mb-4 w-full"
                    />

                    <TextInput
                        label="Confirm New Password"
                        type="password"
                        id="passwordVerify"
                        value={passwordVerify}
                        onChange={setPasswordVerify}
                        className="mb-4"
                    />

                    <button className="btn-save w-full xs:w-auto">
                        {isSaving ? 'Save' : 'Save Changes'}
                    </button>
                </form>
            )}

            <div className="flex mt-6">
                <Link
                    to={`/logout`}
                    className={'btn-light-pill flex items-center justify-center w-full xs:w-auto'}
                >
                    <LogoutIcon className="h-4 w-4 mr-2" aria-hidden="true" />
                    Log Out
                </Link>
            </div>

            <button
                type="button"
                className="mt-6 btn-light-pill w-full xs:w-auto"
                onClick={() => setShowAuditLog(!showAuditLog)}
            >View Audit Log</button>
            {showAuditLog && (
                <div className="mt-2">
                    <AuditLogs
                        id="1"
                        type="business"
                    />
                </div>
            )}
        </div>
    );
};

export default SecuritySettings;
